/**
 * Channel detection — maps `Office.HostType` to the lowercase channel
 * string the backend expects on chat requests.
 *
 * Single source of truth for "which add-in host is this?". Used by
 * `useChat` to send `host: "outlook" | "word" | "powerpoint"` on every
 * `/chat` and `/chat/resume` POST.
 */

export type Channel = "outlook" | "word" | "powerpoint";

export function hostToChannel(
  host: typeof Office.HostType[keyof typeof Office.HostType] | null,
): Channel | null {
  if (host === Office.HostType.Outlook) return "outlook";
  if (host === Office.HostType.Word) return "word";
  if (host === Office.HostType.PowerPoint) return "powerpoint";
  return null;
}
